<template>
	<div class="hello">

		<div  class="search" >
			<el-input v-model="searchTxt" placeholder="请输入城市名称"></el-input>
			<el-button type="primary" @click="searchBtn">查询</el-button>
			<div class="back" v-show="canBack" @click="backHome"></div>
		</div>
		
		

		<!-- 初始化echarts 需要个有宽高的盒子 -->
		<!-- <div ref="mapbox" class="box" :style="'height:'+clientHeight+'px'"> -->
		<div ref="mapbox" class="box">
		</div>

	
	</div>
</template>

<script>

	import axios from 'axios'
	import echarts from 'echarts'
	import 'echarts/map/js/china.js'
	import '../../static/js/citymap.js'
	import '../../static/js/province.js'
	import '../../static/js/provinceLeakrate.js'
	import '../../static/js/cityLeakrate.js'
	
	
	import jsonp from 'jsonp'
	//直辖市和特别行政区-只有二级地图，没有三级地图
	var special = ["北京","天津","上海","重庆","香港","澳门"];
	var mapdata = [];
	var provinceData=[];
	var provinceScale=0.8;
	var china="china"
	var mapName="城市漏损率"
	const option = {
	
		title: {
			text: '2018年中国城市漏损率地图(百分比%)',
			x:'center',  
		},
		series: [{
			//  selectedMode : 'multiple',  // 选中效果固话
			type: 'map', //告诉echarts 渲染地图
			map: 'china',
			label: {
				show: true, //显示各个省份名称
				fontSize: 8,
			},
			itemStyle: {
				areaColor: '#fff' //区域的背景颜色
					//    areaColor: '#323c48', //地图区域的颜色。
                    //     borderColor: '#111', //边框线
			},
			emphasis: {
				//控制鼠标滑过时的高亮样式
				itemStyle: {
					areaColor: '#c7fffd'
				
				},
				// label:{ //文本
                //             color: '#ADA',
                //         },
			},
			zoom: 1.2, //控制地图的大小
		}],
		visualMap: [{
			left:'20%',
			// x:'right',
			type: 'piecewise',
			show: true,
			splitNumber: 6,
			pieces: [{
					min: 25
				}, // 不指定 max，表示 max 为无限大（Infinity）。
				// {
				// 	min: 25,
				// 	max: 30
				// },
				{
					min: 20,
					max:25
				},
				{
					min: 15,
					max: 20
				},
				{
				    min: 12,
					max: 15
				},
				{
					min: 7,
					max: 12
				},
				{
					min: 0,
					max: 7
				},
				{
					min: 0,
					max: 0
				}
				
			],
			//align:'right' // 默认是left
			inRange: {
				symbol: 'rect',
				color: ['#fff', '#ffaa85', '#ff7b69', '#cc2929', '#8c0d0d', '#660208','#660238']
			},
			itemHeight: 10,
			itemWidth: 20
		}],
		tooltip:{
			// position: function (pos, params, dom, rect, size) {
			//       // 鼠标在左侧时 tooltip 显示到右侧，鼠标在右侧时 tooltip 显示到左侧。
			//       var obj = {top: 60};
			//       obj[['left', 'right'][+(pos[0] < size.viewSize[0] / 2)]] = 5;
			//       return obj;
			//   }
			trigger: 'item',
			// formatter: '{a}<br/>{b} : {c}%',
			formatter:function(params)
			{
				let val=mapName+"<br>"+params.name+":"+params.value+"%"
				if(isNaN(params.value))
					val=mapName+"<br>"+params.name+" : "+"暂无数据"
				return val;
			}
		}
	};
	export default {
		name: 'Map',
		data() {
               return {
				   searchTxt:'',
				   clientHeight:450,
				   preIndex:0,
				   pcMap:{},
				   canBack:false
               };
		  },
		created(){
				this.loadPCMap();
		},
		mounted() {
			// document.title="中国水资源数据地图 Powered by 厦门矽创"
			// this.clientHeight=document.body.clientHeight;
			this.clientHeight=window.innerHeight-150;//130
			this.getData();

			if (/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent))
			{
				this.clientHeight=450;
			}

			this.$nextTick(() => {
				this.mychart = echarts.init(this.$refs.mapbox); //获取mapbox盒子
				this.mychart.setOption(option);
				this.mychart.resize();
				let _that=this;
				this.mychart.on('click', function (params) {
						// console.log( params );
						if( params.name in provinces ){
							//如果点击的是34个省、市、自治区，绘制选中地区的二级地图
							_that.setProvince(params.name)
							_that.canBack=true;
						}else if( params.seriesName in provinces ){
							_that.canBack=false;
							//如果是【直辖市/特别行政区】只有二级下钻
							if(  special.indexOf( params.seriesName ) >=0  ){
								_that.renderMap(china,mapdata);
							}else{
								//显示县级地图
								// _that.setCity(params.name);
								_that.renderMap(china,mapdata);
							}	
						}else{
							_that.renderMap(china,mapdata);
							_that.canBack=false;
						}
				});
			  });
			  
			  this.addWaterMarker("厦门矽创");
			
		},
		methods: {
			backHome(){
				this.renderMap(china,mapdata);
				this.canBack=false;
			},
			searchEvent(index)
			{
				  this.mychart.dispatchAction({
									type: 'mapUnSelect', //取消高亮指定的数据图形。
									seriesIndex: 0, // 可选，系列 index，在 tooltip 的 trigger 为 axis 的时候可选。
									dataIndex: this.preIndex// 可选，数据的 index
								 });
								 this.mychart.dispatchAction({
									 type:'mapSelect',
									 seriesIndex:0,
									 dataIndex:index
								 });
								this.mychart.dispatchAction({
									type: 'showTip',
									seriesIndex:0,
									dataIndex: index,
									// position: [50, 50],
								});
								this.preIndex=index;
			},
			loadPCMap(){
					let _that=this;

					for(let  key in provinces)
					{
						if(provinces[key] =="taiwan")
							continue;
						$.getJSON('/static/map/province/'+ provinces[key] +'.json', function(data){
						
							var d = [];
							for( var i=0;i<data.features.length;i++ ){
								d.push(
									data.features[i].properties.name
								)
							}
							_that.pcMap[key]=d
							
						});
					}
					// console.log(this.pcMap)
			},

			setProvince(name,callback){
					let _that=this;
					$.getJSON('/static/map/province/'+ provinces[name] +'.json', function(data){
							echarts.registerMap(name, data);
							var d = [];
							for( var i=0;i<data.features.length;i++ ){
								d.push({
									name:data.features[i].properties.name,
									value:(cityLeakR[data.features[i].properties.name]*100).toFixed(2)
								})
							}
							provinceData=d;
							_that.renderMap(name,d,provinceScale);
							if(callback)
								callback();
						});
			},
			setCity(name){
						let _that=this;
						$.getJSON('/static/map/city/'+ cityMap[name] +'.json', function(data){
								echarts.registerMap( name, data);
								var d = [];
								for( var i=0;i<data.features.length;i++ ){
									let val=(cityLeakR[data.features[i].properties.name]*100).toFixed(2);
									if(isNaN(val))
										val="无数据"
									d.push({
										name:data.features[i].properties.name,
										value:val
									})
								}
								provinceData=d;
								_that.renderMap(name,d,provinceScale);
							});	
			},
			searchBtn(){
				let _that=this;
			
				if( this.searchTxt in provinces ){
						//如果点击的是34个省、市、自治区，绘制选中地区的二级地图
						// this.setProvince(this.searchTxt)
						 this.renderMap(china,mapdata);
						 mapdata.forEach((item,index)=>{
							 if(item.name==this.searchTxt)
							 {
								//  item["selected"]=true;
								//  this.renderMap(mapName,mapdata);
								this.searchEvent(index);
							 }
						 });


					}else if( 
						//  this.searchTxt  in cityMap 
							Object.keys(cityMap).filter((item,index)=>{
								 return item.includes(this.searchTxt);
							 })[0] in cityMap
						 ){
							
						let sertxt=Object.keys(cityMap).filter((item,index)=>{
								 return item.includes(this.searchTxt);
						})[0];
						let name="";
						for(let key in this.pcMap)
						{
							if(this.pcMap[key].includes(sertxt))
							{
								name=key;
								break;
							}
						}
						this.setProvince(name,function(){
							provinceData.forEach((item,index)=>{
							//  if(item.name==_that.searchTxt)
							 if(item.name==sertxt)
							 {
								_that.searchEvent(index);
							 }
						 });
						})
						
						//如果是【直辖市/特别行政区】只有二级下钻
						// if(  special.indexOf(  this.searchTxt  ) >=0  ){
						// 	this.renderMap(mapName,mapdata);
						// }else{
						// 	//显示县级地图
						// 	this.setCity( this.searchTxt );
						// }	
					}else{
						this.$message({
							message: '未找到此城市',
							type: 'warning'
						});
						// this.$message('未找到此城市');
						// this.renderMap(china,mapdata);
					}
			},
			getData() {
				// jsonp(
				// 	'http://interface.sina.cn/news/wap/fymap2020_data.d.json?_=1580892522427', {}, (erros, data) => {
				// 		// console.log(data);
				// 		// console.log(data.data.list)
				// 		var lists = data.data.list.map(item => {
				// 			return {
				// 				name: item.name,
				// 				value: item.value
				// 			}
				// 		})
				// 		console.log(lists)
				// 		option.series[0].data = lists;
				// 		this.mychart.setOption(option);
				// 	});
				let _that=this;
				$.getJSON('/static/map/china.json', function(data){
					let d = [];
					for( var i=0;i<data.features.length;i++ ){
						
						d.push({
							name:data.features[i].properties.name,
							value:(provincesLeakR[data.features[i].properties.name]*100).toFixed(2)
						})
					}
					// d.push(
					//  { name:"南海诸岛",value:0, itemStyle:{ normal:{opacity:0,label:{show:false}} } }
					// )
					mapdata = d;
					//注册地图
					// echarts.registerMap(china, data);
					//绘制地图
					_that.renderMap(china,d);
				});

				// axios.get('static/map/china.json').then(res=>{
				//     let data=res.data;
				// 	let d = [];
				// 	for( var i=0;i<data.features.length;i++ ){
				// 		d.push({
				// 			name:data.features[i].properties.name
				// 		})
				// 	}
				// 	mapdata = d;
				// 	//注册地图
				// 	echarts.registerMap('china', data);
				// 	//绘制地图
				// 	this.renderMap('china',d);
				// })

				
			},
			renderMap(map,data,zoom=1.2){
				
				// option.title.subtext = map;
				option.series = [ 
					{
						name: map,
						type: 'map',
						mapType: map,
						// roam: 'move',
						// nameMap:{
						// 	'china':'中国'
						// },
						label: {
							show: true, //显示各个省份名称
							fontSize: 8,
						},
						itemStyle: {
							areaColor: '#fff' //区域的背景颜色
								//    areaColor: '#323c48', //地图区域的颜色。
								//     borderColor: '#111', //边框线
						},
						emphasis: {
							//控制鼠标滑过时的高亮样式
							itemStyle: {
								areaColor: '#c7fffd'
							},
							// label:{ //文本
							//             color: '#ADA',
							//         },
						},
						zoom:zoom, //控制地图的大小
						data:data
					}	
				];
				//渲染地图
				this.mychart.setOption(option);
			},
			
			addWaterMarker(str){
				var can = document.createElement('canvas');
				var body = document.body;

				body.appendChild(can);

				can.width=200;
				can.height=200;
				can.style.display='none';


				var cans = can.getContext('2d');
				cans.rotate(-30*Math.PI/180);
				cans.font = "16px Microsoft JhengHei";
				cans.fillStyle = "rgba(17, 17, 17, 0.50)";
				cans.textAlign = 'left';
				cans.textBaseline = 'Middle';
				cans.fillText(str,can.width/3,can.height/2);

				body.style.backgroundImage="url("+can.toDataURL("image/png")+")";

			},
						


		}
	}
</script>

<style scoped>
	.back{
		width:50px;
		height:50px;
		float: left;
		margin-left: 10px;
		 background-size: contain;
		background-image: url('../../static/images/back.png')
	}
	.box{
		width: 100%;
		height: calc(100vh - 200px);
		margin: auto;
		/* border: 2px solid aquamarine; */
	}
	
	.search{
		margin-right: 30px;
		text-align: right;
		margin-bottom: 20px;
	}
	.search .el-input{
		width:30%
	}
	@media screen and (max-width:600px) {
		.search .el-input{
			width:50%
		}
	}
</style>
